function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Radio } from "../";
export const RadioLabelLarge = styled.label`
  background-color: ${props => props.checked ? props.theme.colors.actionLight : props.theme.colors.white};
  border: 1px solid
    ${props => props.checked ? props.theme.colors.action : props.theme.colors.border};
  border-radius: 4px;
  box-sizing: border-box;
  display: block;
  padding: 11px 11px 11px 16px;
  margin-bottom: 4px;
  width: 100%;
  cursor: pointer;

  &[disabled] {
    cursor: default;
    background-color: ${props => props.theme.colors.checkboxDisabledUncheckedFill};
    border-color: ${props => props.theme.colors.checkboxDisabledPath};
  }
`;
export const RadioLarge = ({
  children,
  title,
  checked,
  disabled,
  ...props
}) => {
  return React.createElement(RadioLabelLarge, {
    disabled: !!disabled,
    checked: !!checked
  }, React.createElement(Radio, _extends({
    title: title,
    checked: checked,
    disabled: disabled
  }, props), children));
};